<template>
  <line-loader v-if="loading" :size="2" />
  <div v-else>
    <div v-if="!programLogistics.lodging_text_visible && !programLogistics.visa_text_visible && !programLogistics.direction_text_visible && !programLogistics.reimbursement_text_visible">
      <span class="text-muted regular-14">No result</span>
    </div>
    <div v-if="programLogistics.lodging_text_visible">
      <div class="lyon-display-medium-24 mb-2">Lodging</div>
      <div
        class="regular-16 mb-2 custom-html-text"
        v-html="programLogistics.lodging_text"
      />
    </div>
    <div v-if="programLogistics.direction_text_visible">
      <div class="lyon-display-medium-24 mb-2">Directions to Venue</div>
      <div
        class="regular-16 mb-2 custom-html-text"
        v-html="programLogistics.direction_text"
      />
    </div>
    <div v-if="programLogistics.visa_text_visible">
      <div class="lyon-display-medium-24 mb-2">Visa/Immigration</div>
      <div
        class="regular-16 mb-2 custom-html-text"
        v-html="programLogistics.visa_text"
      />
    </div>
    <div v-if="programLogistics.reimbursement_text_visible">
      <div class="lyon-display-medium-24 mb-2">Reimbursement Guidelines</div>
      <div
        class="regular-16 mb-2 custom-html-text"
        v-html="programLogistics.reimbursement_text"
      />
    </div>
  </div>
</template>

<script>
import LineLoader from '@/components/Loaders/LineLoader.vue'

export default {
  name: 'ProgramSignedTab',
  components: { LineLoader },
  data () {
    return {
      programLogistics: {
        lodging_text: '',
        direction_text: '',
        visa_text: '',
        reimbursement_text: ''
      },
      loading: true
    }
  },
  mounted() {
    this.loadProgramLogistics()
  },
  methods: {
    loadProgramLogistics () {
      this.loading = true
      this.$http.get(process.env.VUE_APP_API_URL + `/programs/${this.$route.params.id}/show_program_logistics`)
      .then((res) => {
        if(res) {
          this.programLogistics = res.data
        }
        this.loading = false
      })
    }
  }
}
</script>
